import trMessages from "./messages/tr_TR.json";

const messages = {
  "tr-tr": trMessages
};

export default messages;



